import React, { useState, useEffect } from "react";
import { referralDiscount } from "../../../AxiosRtk/Settings";
import DiscountItemCard from "./DiscountItemCard";
import CopyToClipboard from "react-copy-to-clipboard";
import InfoMessage from "../../modals/InfoMessage";
import SuccessMessage from "../../modals/SuccessMessage";
import { useDispatch, useSelector } from "react-redux";
import {
  createPaymentIntent,
  getPriceFromStripe,
} from "../../../AxiosRtk/Subscription/SUBSCRIPTIONCURD";
import Swal from "sweetalert2";

const ManageSubscription = ({ subscriptionData, getLangTranslation }) => {
  const dispatch = useDispatch();
  const [isRadioChecked, setIsRadioChecked] = useState(0);
  const [discountList, setDiscountList] = useState([]);
  const [referralCode, setRefCode] = useState("");
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [showSuccessModal, setSuccessModal] = useState(false);

  const { priceList, discount, stripeDirectUrl } = useSelector(
    ({ subscription }) => subscription
  );

  const handleCardClick = (checked) => {
    if (subscriptionData && subscriptionData?.daysRemaining > 4) {
      Swal.fire({
        icon: "info",
        text: getLangTranslation(
          "SETTING_SUBSCRIPTION_YOUR_SUBSCRIPTION_ALREADY_GOING_ON",
          "You have already a valid subscription!"
        ),
      });
    } else {
      setIsRadioChecked(checked);
      dispatch(createPaymentIntent(checked));
    }
  };

  useEffect(() => {
    dispatch(getPriceFromStripe({}));
    referralDiscount()
      .then((res) => {
        setDiscountList(res?.data?.result?.list);
        setRefCode(res?.data?.result?.referralLink?.toUpperCase());
      })
      .catch((err) => {
        console.log(
          "referral discount catch error ===>>>",
          err?.response?.data?.message
        );
      });
  }, []);

  function closeModal() {
    setShowInfoModal(false);
  }

  function closeSuccessModal() {
    setSuccessModal(false);
  }
  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );

  const closeSubscriptionDrawer = (e) => {
    if (stripeDirectUrl) {
      window.location.href = stripeDirectUrl;
    }
    if (!stripeDirectUrl) {
      Swal.fire({
        icon: "info",
        text: getLangTranslation(
          "SETTING_SUBSCRIPTION_SELECT_SUBSCRIPTION_PLAN",
          "Select subscription plan"
        ),
      });
    }
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center gap-2 mb-6 flex-wrap">
        {/* <h5 className="mb-0">
          {getLangTranslation(
            "SETTING_SUBSCRIPTION_SELECT_SUBSCRIPTION_PLAN",
            "Select subscription plan"
          )}
        </h5> */}
        {false && (
          <button
            className="btn btn-primary"
            type="button"
            onClick={() => {
              closeSubscriptionDrawer();
            }}
          >
            <span className="btn-upper-case">
              {getLangTranslation("SETTINGS_SUBSCRIBE_NOW", "Subscribe now")}
            </span>
          </button>
        )}
      </div>

      <div className="mb-6 bg-light rounded-3 p-4">
        <p className="mb-3">
          <span className="text-black fw-semibold">
            {getLangTranslation(
              "SETTING_SUBSCRIPTION_MANAGE_TITLE",
              "Subscription purchases through the web portal are currently unavailable."
            )}
          </span>
        </p>
        <p className="mb-3">
          {getLangTranslation(
            "SETTING_SUBSCRIPTION_MANAGE_DESCRIPTION_PREFIX",
            "For the best experience, please purchase your subscription directly through the"
          )}{" "}
          <strong>
            {getLangTranslation(
              "SETTING_SUBSCRIPTION_MANAGE_DESCRIPTION_PARENTAL_CONTROL",
              "Parental Control:"
            )}
          </strong>{" "}
          <span className="text-black fw-semibold">
            {getLangTranslation(
              "SETTING_SUBSCRIPTION_MANAGE_DESCRIPTION_SUFFIX",
              "Kido Protect App."
            )}
          </span>
        </p>
        <p className="mb-2">
          <span className="text-black fw-semibold">
            {getLangTranslation(
              "SETTING_SUBSCRIPTION_MANAGE_DOWNLOAD_TEXT",
              "Download Kido Protect:"
            )}
          </span>
        </p>
        <p className="mb-3">
          <a
            href="https://play.google.com/store/apps/details?id=com.kidoprotect.app"
            target="_blank"
            rel="noreferrer"
          >
            https://play.google.com/store/apps/details?id=com.kidoprotect.app
          </a>
        </p>
        <p className="mb-0">
          {getLangTranslation(
            "SETTING_SUBSCRIPTION_MANAGE_THANK_YOU_TEXT",
            "Thank you for your understanding."
          )}
        </p>
      </div>

      {false && (
        <div className="grid gap-6">
          {priceList
            ?.filter((item) => (item?.active === true && item?.recurring?.interval !== "day"))
            .map((item) => (
              <div className="g-col-12 g-col-md-6" key={item?.id}>
                <div
                  className={`card pt-cursor ${isRadioChecked === item?.id
                    ? "border-blue-400"
                    : "border-blue-100"
                    }`}
                  onClick={() => {
                    handleCardClick(item?.id);
                  }}
                >
                  <div className="card-body">
                    <div className="d-flex align-items-center gap-6 flex-wrap">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="createTask"
                        checked={isRadioChecked === item?.id}
                        onChange={() => { }}
                      />
                      <div className="flex-fill">
                        <div className="d-flex align-items-center gap-6 mb-1 flex-wrap">
                          <h6 className="mb-0">
                            ${item?.unit_amount / 100}/
                            {item?.recurring?.interval}
                          </h6>
                          <div className="badge rounded-pill bg-primary w-auto px-2 py-1 text-small h-auto">
                            Gold
                          </div>
                        </div>
                        <p className="text-small text-gray mb-0">
                          {/* Billed $15 every , 30 days money back guarantee */}
                          {getLangTranslation(
                            "SUBSCRIBTION_PLAN_PER_MONTH_PRICE_WITH_DATE",
                            "Billed $price$ every $interval$, $days$ days money back guarantee"
                          )
                            ?.replace("price$", `${item?.unit_amount / 100}`)
                            ?.replace(
                              "$interval$",
                              `${item?.recurring?.interval === "year"
                                ? "year"
                                : "month"
                              }`
                            )
                            ?.replace("$days$", 30)}
                        </p>
                      </div>
                    </div>
                    <hr className="my-3" />
                    <ul
                      className={`list-unstyled mb-0 ${lang?.isRTL === 1 ? "pe-0" : ""
                        }`}
                    >
                      <li className="d-flex align-items-center  gap-2 mb-3">
                        <i className="icon-check-round-one fs-4 text-primary" />
                        <h6 className="text-gray-500 mb-0">
                          {getLangTranslation(
                            "SUBSCRIBE_MONITOR_ACTIVITY",
                            "Monitor All Child Activities"
                          )}
                        </h6>
                      </li>
                      <li className="d-flex align-items-center gap-2 mb-3">
                        <i className="icon-check-round-one fs-4 text-primary" />
                        <h6 className="text-gray-500 mb-0">
                          {getLangTranslation(
                            "SUBSCRIBE_LOCATE_FAMILY",
                            "Location, Geofencing And More"
                          )}
                        </h6>
                      </li>
                      <li className="d-flex align-items-center gap-2 mb-3">
                        <i className="icon-check-round-one fs-4 text-primary" />
                        <h6 className="text-gray-500 mb-0">
                          {getLangTranslation(
                            "SUBSCRIBE_MANUAL_SCREENSHOT",
                            "Monitor Social Media Apps"
                          )}
                        </h6>
                      </li>
                      <li className="d-flex align-items-center gap-2 mb-3">
                        <i className="icon-check-round-one fs-4 text-primary" />
                        <h6 className="text-gray-500 mb-0">
                          {getLangTranslation(
                            "SUBSCRIBE_TRACK_CALLS_SMS",
                            "Instant And Custom Screenshot Anywhere"
                          )}
                        </h6>
                      </li>
                      <li className="d-flex align-items-center gap-2 mb-3">
                        <i className="icon-check-round-one fs-4 text-primary" />
                        <h6 className="text-gray-500 mb-0">
                          {getLangTranslation(
                            "SUBSCRIBE_FILTER_CONTENT_APPS",
                            "Images Smart Analyze And Threat Detection"
                          )}
                        </h6>
                      </li>
                      <li className="d-flex align-items-center gap-2 mb-3">
                        <i className="icon-check-round-one fs-4 text-primary" />
                        <h6 className="text-gray-500 mb-0">
                          {getLangTranslation(
                            "SUBSCRIBE_REPORTS_ALERTS_SOS",
                            "Track Calls & SMS"
                          )}
                        </h6>
                      </li>
                      <li className="d-flex align-items-center gap-2 mb-3">
                        <i className="icon-check-round-one fs-4 text-primary" />
                        <h6 className="text-gray-500 mb-0">
                          {getLangTranslation(
                            "SUBSCRIBE_NUDITY_DETECTION",
                            "Filter Web Content And Apps"
                          )}
                        </h6>
                      </li>
                      <li className="d-flex align-items-center gap-2 mb-3">
                        <i className="icon-check-round-one fs-4 text-primary" />
                        <h6 className="text-gray-500 mb-0">
                          {getLangTranslation(
                            "SUBSCRIBE_TEXT_DETECTION_IN_SOCIAL_MEDIA",
                            "Smart Online And Social Media Threat Detection"
                          )}
                        </h6>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            ))}
        </div>
      )}

      <hr className="my-6" />

      <div className="d-flex justify-content-between align-items-center gap-3 mb-6 flex-wrap">
        <h5 className="mb-0">
          {getLangTranslation(
            "SETTINGS_REFER_OTHER_PARENT_GET_DISCOUNT",
            "Refer other parents and get a discount on your next payment"
          )}
        </h5>
        <div className="d-flex align-items-center gap-2">
          <CopyToClipboard
            text={referralCode}
            onCopy={() => setShowInfoModal(true)}
          >
            <button className="btn btn-outline-primary" type="button">
              <span className="btn-upper-case">
                {getLangTranslation(
                  "SETTINGS_GENERATE_REFERAL_CODE",
                  "generate the referral code"
                )}
              </span>
            </button>
          </CopyToClipboard>
          <CopyToClipboard
            text={`${window.location.origin}/sign-up?Refferal=${referralCode}`}
            onCopy={() => setSuccessModal(true)}
          >
            <button className="btn btn-primary" type="button">
              <span className="btn-upper-case">
                {getLangTranslation("SETTINGS_SHARE_TEXT", "Share")}
              </span>
            </button>
          </CopyToClipboard>
        </div>
      </div>
      <div className="row g-3">
        {discountList?.map((item) => {
          return (
            <DiscountItemCard
              item={item}
              getLangTranslation={getLangTranslation}
              key={item?.ID}
            />
          );
        })}
      </div>
      <InfoMessage
        showModal={showInfoModal}
        closeModal={closeModal}
        getLangTranslation={getLangTranslation}
        message={[
          `${getLangTranslation(
            "SETTING_SUBSCRIPTION_DISCOUNT_YOUR_REFERRAL_CODE",
            "Your referral code"
          )} ${referralCode}`,
          getLangTranslation(
            "SETTING_SUBSCRIPTION_DISCOUNT_CODE_COPIED_TO_CLIPBOARD",
            "Code copied to clipboard"
          ),
        ]}
      />
      <SuccessMessage
        showModal={showSuccessModal}
        closeModal={closeSuccessModal}
        getLangTranslation={getLangTranslation}
        message="LINK_COPIED_TO_CLIPBOARD"
        value="Link copied to clipboard"
      />
    </>
  );
};

export default ManageSubscription;
